import { input, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export type AvatarSize = 'small' | 'normal' | 'large' | 'xlarge' | 'fill';

export type AvatarShape = 'square' | 'circle' | 'rounded';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'avatar',
    '[class]': '"avatar_" + size()',
    '[class.avatar_circle]': 'shape() === "circle"',
    '[class.avatar_rounded]': 'shape() === "rounded"',
    '[style.backgroundColor]': 'color()',
  },
})
export class AvatarComponent {
  size = input<AvatarSize>('normal');

  shape = input<AvatarShape>('rounded');

  color = input<string | undefined>('#9EA5B2');

  src = input<string | undefined>();

  label = input<string | undefined>();

  alt = input<string | undefined>();
}
